module.exports = __webpack_public_path__ + "assets/img/goods-signature.b3c9d5ba.png";